module.exports = __webpack_public_path__ + "img/sofort.c28967fa.svg";